import { Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { SyncLoader } from "react-spinners";
import NoDataPrompt from "../NoDataPrompt/NoDataPrompt";
import "./Table.css";
import React from "react";
export default function Table({
    tableHeaders,
    headerSelector,
    tableData,
    ActionBtn,
    ViewBtn,
    PendingBtn,
    showLoader,
}) {
    function extractRemarks(value){
        var remarksInputValue = ""
        value.map((data)=>{
        remarksInputValue += data.split(":")[1] + ", "
    })  
    return remarksInputValue
    }
    const columns = tableHeaders.map((header, index) => {
        if (header === "-") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: ViewBtn,
                width: "7vw",
                reorder: false,
            };
        }
        else if (header === "Name") {
            return {
                name: header,
                cell: (row) => {
                    const names = row.names.split("|")
                    var namesString = "";
                    names.map((data, index) => {
                        if(names.length - 1 !== index) {
                            namesString += data + ", "
                        } else {
                            namesString += data
                        }
                    })
                    return namesString
                },
                reorder: true,
            };
        } 
        else if (header === "Amount") {
            return {
                name: header,
                cell: (row) => {
                    const amount = row.amount.split("|")
                    var amountString = "";
                    amount.map((data, index) => {
                        if(amount.length - 1 !== index) {
                            amountString += data + ", "
                        } else {
                            amountString += data
                        }
                    })
                    return amountString
                },
                reorder: true,
            };
        } 
        else if (header === "ID No.") {
            return {
                name: header,
                cell: (row) => {
                    const amount = row.ids.split("|")
                    var amountString = "";
                    amount.map((data, index) => {
                        if(amount.length - 1 !== index) {
                            amountString += data + ", "
                        } else {
                            amountString += data
                        }
                    })
                    return amountString
                },
                reorder: true,
                width: "13vw",
            };
        } 
         else if (header === "ACTIONS") {
            return {
                name: header,
                button: true,
                cell: ActionBtn,
                // width: "15vw",
                reorder: true,
            };
        } 
        else if (header === " ") {
            return {
                name: header,
                button: true,
                cell: PendingBtn,
                width: "10vw",
                reorder: true,
            };
        } else if (header.includes("REMARKS")) {
            return {
                name: header,
                selector: (row) => extractRemarks(row[headerSelector[index]]),
                sortable: true,
                width: "15vw",
                reorder: true,
            };
        } else if(header==="SALES DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "35vw",
                reorder: true,
            };
        } else if(header==="GRAB PRICE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "12vw",
                reorder: true,
                right: true
            };
        } else if(header==="FOOD PANDA PRICE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "18vw",
                reorder: true,
                right: true
            };
        }else if(header==="REMARK") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                reorder: true,
            };
        } else if(header==="GROSS SALES" ||  header === "SALES DISCOUNT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "15vw",
                reorder: true,
                right: true
            };
        }else if(header==="SI. FROM" || header==="SI. TO" || header==="SI. NO." || header==="ID NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
            };
        } else if(header==="VAT SALES" || header==="VAT EXEMPT SALES" || header==="NET VATABLE SALES" || header==="ZERO-RATED" || header==="TOTAL SALES" || header==="GROSS VAT SALES" || header==="TOTAL VAT" || header==="NET VAT" || header==="PWD DISC." || header==="SENIOR DISC." || header==="OTHER DISC." || header==="TOTAL DISC." || header==="VAT EXEMPT" || header==="TOTAL TAX" || header==="GRAND TOTAL" ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "15vw",
                right: true,
                reorder: true,
            };
        } else if(header==="VAT DISCOUNT SALES" || header==="TYPE" || header==="SALES"|| header.includes("FULL NAME")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "35vw",
                reorder: true,
            };
        } else if(header === "ITEM NAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                // width: "20vw",
                reorder: true,
            };
        } 
        else if(header==="CASHIER" || header==="DATE" || header==="DATE ADDED" || header==="OVER/SHORT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "15vw",
                reorder: true,
            };
        } 
        else if (header.includes("DESCRIPTION") || header.includes("FILE") ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "15vw",
                reorder: true,
            };
        } else if (header.includes("USERNAME")  ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "25vw",
                reorder: true,
            };
        }else if ( header.includes("NAME") || header === "DATE RECEIVED" ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "20vw",
                reorder: true,
            };
        }else if (header.includes("COUNT") || header.includes("QTY")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "50vw",
                reorder: true,
                right: true
            };
        }else if (header.includes("EXPECTED CNT.") || header.includes("PHYSICAL CNT.") || header.includes("OVER / SHORT") || header.includes("INITIAL DRAWER") || header.includes("TOTAL") || header.includes("Subtotal") || header.includes("Discounted Amount")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "20vw",
                reorder: true,
                right: true
            };
        }  else if (header.includes("PRICE") || header.includes("QUANTITY") || header.includes("AMOUNT") || header.includes("TOTAL AMOUNT") ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "13vw",
                reorder: true,
                right: true
            };
        } else if (header.includes("CATEGORIES")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "15vw",
                reorder: true,
            };
        } else if (header.includes("REMARK")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "80vw",
                reorder: true,
            };
        } else if (header.includes("CATEGORY")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                // width: "78vw",
                reorder: true,
            };
        }
        else if (header.includes("ITEM NAME")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                // width: "100vw",
                reorder: true,
            };
        }else if (header === "QTY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "15vw",
                reorder: true,
                center: true,
            };
        }  else if (header.includes("ROLE") || header.includes("TYPE") ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "20vw",
                reorder: true,
            };
        } else if (header.includes("DATE") || header === "ADDED BY" ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "11vw",
                reorder: true,
            };
        }  else {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                reorder: true,
            };
        }
    });
// 
    const paginationComponentOptions = {
        rowsPerPageText: "",
        noRowsPerPage: true,
    };

    const customStyles = {
        rows: {
            style: {
                minHeight: "5.2vh",
            },
        },
    };

    return showLoader ? (
        <div className="d-flex justify-content-center my-5">
            <SyncLoader color="var(--primary-color)" size={15} />
        </div>
    ) : (
        <DataTable
            pagination
            // striped
            fixedHeader
            fixedHeaderScrollHeight="50vh"
            columns={columns}
            data={tableData}
            customStyles={customStyles}
            paginationComponentOptions={paginationComponentOptions}
            progressPending={showLoader}
            noDataComponent={<NoDataPrompt />}
        />
    );
}
